import ApplicationController from '../../application_controller'

// Expand/collapse for the Score card + detail panel, syncing their heights via JS
// (only relevant when they're actually side-by-side -- see reflowLayout).
export default class extends ApplicationController {
  static targets = ['expandBtn', 'collapseBtn', 'scoreExtra', 'scoreWrapper', 'detailPanel']

  connect() {
    super.connect()
    // Detail panel's real (desktop) home -- so it can be moved for stacked layouts and
    // restored exactly, without touching the DOM/CSS of the 2-column desktop layout at all.
    this.detailPanelHome = this.detailPanelTarget.parentElement
    this.detailPanelHomeNextSibling = this.detailPanelTarget.nextElementSibling

    this.stackedQuery = window.matchMedia('(max-width: 991.98px)')
    this.handleLayoutChange = this.handleLayoutChange.bind(this)
    this.stackedQuery.addEventListener('change', this.handleLayoutChange)
    this.handleLayoutChange()
  }

  disconnect() {
    this.stackedQuery.removeEventListener('change', this.handleLayoutChange)
  }

  // Stacked (mobile): detail panel moves right after the Score card/tabs, before
  // Organizations. Desktop: restored to its original spot in the right column.
  handleLayoutChange() {
    if (this.stackedQuery.matches) {
      this.scoreExtraTarget.after(this.detailPanelTarget)
    } else if (this.detailPanelHomeNextSibling) {
      this.detailPanelHome.insertBefore(this.detailPanelTarget, this.detailPanelHomeNextSibling)
    } else {
      this.detailPanelHome.appendChild(this.detailPanelTarget)
    }
    this.syncHeights()
  }

  expand() {
    this.expandBtnTarget.classList.add('d-none')
    this.collapseBtnTarget.classList.remove('d-none')
    this.scoreExtraTarget.classList.remove('d-none')
    this.detailPanelTarget.classList.remove('d-none')
    this.syncHeights()
  }

  collapse() {
    this.collapseBtnTarget.classList.add('d-none')
    this.expandBtnTarget.classList.remove('d-none')
    this.scoreExtraTarget.classList.add('d-none')
    this.detailPanelTarget.classList.add('d-none')

    this.scoreWrapperTarget.style.minHeight = ''
    this.detailPanelTarget.style.minHeight = ''
  }

  // Only matches heights when side-by-side (desktop) -- stacked layout needs no matching,
  // it would just leave dead space under whichever card is naturally shorter.
  syncHeights() {
    this.scoreWrapperTarget.style.minHeight = ''
    this.detailPanelTarget.style.minHeight = ''

    if (this.stackedQuery.matches) return

    const tallest = Math.max(this.scoreWrapperTarget.offsetHeight, this.detailPanelTarget.offsetHeight)
    this.scoreWrapperTarget.style.minHeight = `${tallest}px`
    this.detailPanelTarget.style.minHeight = `${tallest}px`
  }
}
